import { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = "/api";

export default function Clients() {

    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    const [form, setForm] = useState({
        clientName: "",
        email: "",
        mobile: "",
        gstin: "",
        pan: "",
        billingAddress: "",
        shippingAddress: "",
        city: "",
        state: "",
        pincode: ""
    });

    const companyId = localStorage.getItem("companyId") || "1";

    const getToken = () => {
        return localStorage.getItem("token");
    };

    const loadClients = async () => {

        try {

            setLoading(true);
            setError("");

            const response = await axios.get(
                `${API_BASE}/clients?companyId=${companyId}`
            );

            setClients(response.data || []);

        } catch (err) {

            console.error("Client loading error:", err);

            setError("Unable to load clients");

        } finally {

            setLoading(false);

        }
    };

    useEffect(() => {
        loadClients();
    }, []);

    const handleChange = (e) => {

        const { name, value } = e.target;

        setForm({
            ...form,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!form.clientName.trim()) {
            alert("Please enter client name");
            return;
        }

        try {

            setSaving(true);

            await axios.post(
                `${API_BASE}/clients?companyId=${companyId}`,
                {
                    ...form
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${getToken()}`
                    }
                }
            );

            alert("Client added successfully");

            setForm({
                clientName: "",
                email: "",
                mobile: "",
                gstin: "",
                pan: "",
                billingAddress: "",
                shippingAddress: "",
                city: "",
                state: "",
                pincode: ""
            });

            setShowForm(false);

            loadClients();

        } catch (err) {

            console.error("Client save error:", err);

            if (err.response?.data) {
                alert(
                    typeof err.response.data === "string"
                        ? err.response.data
                        : "Unable to save client"
                );
            } else {
                alert("Unable to save client");
            }

        } finally {

            setSaving(false);

        }
    };

    return (
        <div>

            {/* Page Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">

                <div>
                    <h3 className="mb-1">Clients</h3>

                    <p className="text-muted mb-0">
                        Manage your invoice clients
                    </p>
                </div>

                <button
                    className="btn btn-primary"
                    onClick={() => setShowForm(!showForm)}
                >
                    {showForm ? "Close" : "+ Add Client"}
                </button>

            </div>


            {/* Add Client Form */}
            {showForm && (

                <div className="card shadow-sm border-0 mb-4">

                    <div className="card-header bg-white">
                        <h5 className="mb-0">
                            Add New Client
                        </h5>
                    </div>

                    <div className="card-body">

                        <form onSubmit={handleSubmit}>

                            <div className="row g-3">

                                <div className="col-md-6">

                                    <label className="form-label">
                                        Client Name *
                                    </label>

                                    <input
                                        type="text"
                                        name="clientName"
                                        className="form-control"
                                        value={form.clientName}
                                        onChange={handleChange}
                                        placeholder="Enter client name"
                                        required
                                    />

                                </div>


                                <div className="col-md-3">

                                    <label className="form-label">
                                        Email
                                    </label>

                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        value={form.email}
                                        onChange={handleChange}
                                        placeholder="client@email.com"
                                    />

                                </div>


                                <div className="col-md-3">

                                    <label className="form-label">
                                        Mobile
                                    </label>

                                    <input
                                        type="text"
                                        name="mobile"
                                        className="form-control"
                                        value={form.mobile}
                                        onChange={handleChange}
                                        placeholder="Mobile number"
                                    />

                                </div>


                                <div className="col-md-3">

                                    <label className="form-label">
                                        GSTIN
                                    </label>

                                    <input
                                        type="text"
                                        name="gstin"
                                        className="form-control"
                                        value={form.gstin}
                                        onChange={handleChange}
                                        placeholder="GSTIN"
                                    />

                                </div>


                                <div className="col-md-3">

                                    <label className="form-label">
                                        PAN
                                    </label>

                                    <input
                                        type="text"
                                        name="pan"
                                        className="form-control"
                                        value={form.pan}
                                        onChange={handleChange}
                                        placeholder="PAN"
                                    />

                                </div>


                                <div className="col-md-6">

                                    <label className="form-label">
                                        Billing Address
                                    </label>

                                    <textarea
                                        name="billingAddress"
                                        className="form-control"
                                        rows="2"
                                        value={form.billingAddress}
                                        onChange={handleChange}
                                        placeholder="Billing address"
                                    />

                                </div>


                                <div className="col-md-6">

                                    <label className="form-label">
                                        Shipping Address
                                    </label>

                                    <textarea
                                        name="shippingAddress"
                                        className="form-control"
                                        rows="2"
                                        value={form.shippingAddress}
                                        onChange={handleChange}
                                        placeholder="Shipping address"
                                    />

                                </div>


                                <div className="col-md-4">

                                    <label className="form-label">
                                        City
                                    </label>

                                    <input
                                        type="text"
                                        name="city"
                                        className="form-control"
                                        value={form.city}
                                        onChange={handleChange}
                                    />

                                </div>


                                <div className="col-md-4">

                                    <label className="form-label">
                                        State
                                    </label>

                                    <input
                                        type="text"
                                        name="state"
                                        className="form-control"
                                        value={form.state}
                                        onChange={handleChange}
                                    />

                                </div>


                                <div className="col-md-4">

                                    <label className="form-label">
                                        Pincode
                                    </label>

                                    <input
                                        type="text"
                                        name="pincode"
                                        className="form-control"
                                        value={form.pincode}
                                        onChange={handleChange}
                                    />

                                </div>

                            </div>


                            <div className="mt-4">

                                <button
                                    type="submit"
                                    className="btn btn-success"
                                    disabled={saving}
                                >
                                    {saving
                                        ? "Saving..."
                                        : "Save Client"}
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-secondary ms-2"
                                    onClick={() => setShowForm(false)}
                                >
                                    Cancel
                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            )}


            {/* Error */}
            {error && (

                <div className="alert alert-danger">
                    {error}
                </div>

            )}


            {/* Clients List */}
            <div className="card shadow-sm border-0">

                <div className="card-header bg-white d-flex justify-content-between align-items-center">

                    <h5 className="mb-0">
                        Client List
                    </h5>

                    <span className="badge bg-primary">
                        {clients.length} Clients
                    </span>

                </div>


                <div className="card-body p-0">

                    {loading ? (

                        <div className="text-center p-5">
                            <div
                                className="spinner-border text-primary"
                                role="status"
                            >
                            </div>

                            <p className="mt-3 mb-0">
                                Loading clients...
                            </p>
                        </div>

                    ) : clients.length === 0 ? (

                        <div className="text-center p-5">

                            <h5>
                                No Clients Found
                            </h5>

                            <p className="text-muted">
                                Add your first client to create invoices.
                            </p>

                            <button
                                className="btn btn-primary"
                                onClick={() => setShowForm(true)}
                            >
                                + Add Client
                            </button>

                        </div>

                    ) : (

                        <div className="table-responsive">

                            <table className="table table-hover mb-0">

                                <thead className="table-light">

                                    <tr>

                                        <th>#</th>
                                        <th>Client Name</th>
                                        <th>Email</th>
                                        <th>Mobile</th>
                                        <th>GSTIN</th>
                                        <th>City</th>
                                        <th>Status</th>
                                        <th>Action</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    {clients.map((client, index) => (

                                        <tr key={client.id || index}>

                                            <td>
                                                {index + 1}
                                            </td>

                                            <td>
                                                <strong>
                                                    {client.clientName}
                                                </strong>
                                            </td>

                                            <td>
                                                {client.email || "-"}
                                            </td>

                                            <td>
                                                {client.mobile || "-"}
                                            </td>

                                            <td>
                                                {client.gstin || "-"}
                                            </td>

                                            <td>
                                                {client.city || "-"}
                                            </td>

                                            <td>

                                                <span
                                                    className={
                                                        client.status === "INACTIVE"
                                                            ? "badge bg-secondary"
                                                            : "badge bg-success"
                                                    }
                                                >
                                                    {client.status || "ACTIVE"}
                                                </span>

                                            </td>

                                            <td>

                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={() =>
                                                        alert(
                                                            "Invoice module coming next"
                                                        )
                                                    }
                                                >
                                                    Create Invoice
                                                </button>

                                            </td>

                                        </tr>

                                    ))}

                                </tbody>

                            </table>

                        </div>

                    )}

                </div>

            </div>

        </div>
    );
}